import { withInstall } from '@/utils'
import ExportBtn from './src/exportBtn.vue'
export default withInstall(ExportBtn)
